<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <div class="d-flex align-center">
          <h2 class="mx-3" v-if="$vuetify.display.mdAndUp">Log delle attività</h2>
          <h3 class="mx-3" v-else>Log delle attività</h3>
        </div>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete  v-model="query.user" label="Filtra per operatore" clearable :items="userOptions" hide-details @update:model-value="saveQuery()" autocomplete="off"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-autocomplete  v-model="query.itemuser" label="Filtra per cliente" clearable :items="userOptions" hide-details @update:model-value="saveQuery()" autocomplete="off"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select  v-model="query.collection" label="Filtra per tipologia" clearable :items="collectionOptions" hide-details @update:model-value="saveQuery()" autocomplete="off"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select  v-model="query.operation" label="Filtra per operazione" clearable :items="operationOptions" hide-details @update:model-value="saveQuery()" autocomplete="off"></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field  v-model="query.from" type="date" label="Data da" clearable hide-details @update:model-value="saveQuery()" autocomplete="off"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field  v-model="query.to" type="date" label="Data a" clearable hide-details @update:model-value="saveQuery()" autocomplete="off"></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <data-table :headers="headers" collection="logs" view-sub-path="" :viewable="false" :editable="false" deletable
                    :limit-options="[{title:'25', value: 25},{title:'50', value: 50},{title:'100', value: 100},{title:'200', value: 200}]"
                    :query="query" :default-sort="{key : 'date', order : 'desc'}" @error="onListError" :default-limit="100">
          <template #item.user.surname="{item}">
            <a v-if="item.user" @click="$router.push(`/users/${item._id}`)">{{item.user.surname}} {{item.user.name}} ({{item.user.email}})</a>
            <span v-else>{{item.user_id}} (utente eliminato)</span>
          </template>
          <template #item.date="{item}">
            {{formatDateTime(item.date)}}
          </template>
          <template #item.collection="{item}">
            <a v-if="item.collection === 'user_seats'">
              Sedute di {{item.item ? getUserName(item.item.user_id) : '-'}}
            </a>
            <a v-if="item.collection === 'purchases'">
              Acquisto di {{item.item ? getUserName(item.item.user_id) : '-'}}
            </a>
            <a v-if="item.collection === 'extra_seats'">
              Tempo-extra di {{item.item ? getUserName(item.item.user_id) : '-'}}
            </a>
          </template>
          <template #item.operation="{item}">
            <span v-if="item.operation === 'update'">Modifica</span>
            <span v-if="item.operation === 'create'">Inserimento</span>
            <span v-if="item.operation === 'delete'">Cancellazione</span>
          </template>
          <template #item.changed_fields="{item}">
            <ul v-if="item.changed_fields">
              <li v-for="(f,i) in item.changed_fields" :key="`${item._id}_${i}`"><strong>{{f.name}}</strong>: {{f.old_value}} -> {{f.value}}</li>
            </ul>
          </template>
          <template #item.item="{item}">
            <v-btn color="primary" icon="mdi-clipboard-text-search-outline" density="compact" @click="openDetail(item)"></v-btn>
          </template>
        </data-table>
      </v-col>
    </v-row>

    <v-dialog max-width="1380" v-model="detailDialog">
      <v-card>
        <v-card-text v-if="detailItem">
          <v-row density="compact">
            <v-col cols="12" class="d-flex justify-space-between">
              <div>
                <h3 class="my-0">
                  Dettaglio
                  <span v-if="detailItem.operation === 'create'">inserimento</span>
                  <span v-if="detailItem.operation === 'update'">modifica</span>
                  <span v-if="detailItem.operation === 'delete'">cancellazione</span>
                  di
                  <span v-if="detailItem.collection === 'user_seats'">sedute utente</span>
                  <span v-if="detailItem.collection === 'purchases'">vendita</span>
                  <span v-if="detailItem.collection === 'extra_seats'">tempo extra sedute</span>
                </h3>
                <p class="my-0">Data: {{formatDateTime(detailItem.date)}}</p>
                <p class="my-0">Utente operazione: {{getUserName(detailItem.user_id)}}</p>
              </div>
              <v-btn icon="mdi-close" density="compact" variant="text" @click="detailDialog = false"></v-btn>
            </v-col>
            <v-col v-if="detailItem.old_item" cols="12" lg="6">
              <!-- OLD ITEM -->
              <h4 class="mt-0">Elemento precedente</h4>
              <user-seat-card v-if="detailOldUserSeat" :model-value="detailOldUserSeat"></user-seat-card>
              <extra-seat-pause-card v-if="detailOldExtraSeatsPause" :model-value="detailOldExtraSeatsPause"></extra-seat-pause-card>
              <purchase-card v-if="detailOldPurchase" :model-value="detailOldPurchase"></purchase-card>
            </v-col>
            <v-col cols="12" :lg="detailItem.old_item ? 6 : 12">
              <!-- NEW ITEM -->
              <h4 class="mt-0">Elemento nuovo</h4>
              <user-seat-card v-if="detailUserSeat" :model-value="detailUserSeat" :changed-fields="detailOldUserSeat ? detailItem.changed_fields : undefined"></user-seat-card>
              <extra-seat-pause-card v-if="detailExtraSeatsPause" :model-value="detailExtraSeatsPause" :changed-fields="detailOldExtraSeatsPause ? detailItem.changed_fields : undefined"></extra-seat-pause-card>
              <purchase-card v-if="detailPurchase" :model-value="detailPurchase"></purchase-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-dialog>

  </v-container>
</template>

<script lang="ts">
import {computed, defineComponent, inject, onBeforeMount, onMounted, ref} from 'vue'
import FormHeader from "@/components/FormHeader.vue";
import type {Globals} from "@/plugins/globals.ts";
import DataTable from "@/components/DataTable.vue";
import {
  type DataTableError,
  type ExtraSeatsPause, isExtraSeatsPause, isPurchase,
  isUserSeat,
  type Purchase, type Query,
  type TopGymLog,
  type UserSeat
} from "@/models.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Auth} from "@/plugins/auth.ts";
import utils from "@/utils";
import UserSeatCard from "@/components/UserSeatCard.vue";
import ExtraSeatPauseCard from "@/components/ExtraSeatPauseCard.vue";
import PurchaseCard from "@/components/PurchaseCard.vue";


export default defineComponent({
  name: "Logs",
  components: {PurchaseCard, ExtraSeatPauseCard, UserSeatCard, DataTable, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const query = ref<Query>({})

    onBeforeMount(()=>{
      query.value = utils.getSessionQuery("logs")
    })

    onMounted(async ()=>{

      await Promise.all([
        globals.refreshEmpty("users"),
        globals.refreshEmpty("purchases"),
        globals.refreshEmpty("products"),
      ])
    })


    const detailDialog = ref(false)
    const detailItem = ref<TopGymLog|undefined>()
    const detailUserSeat = ref<UserSeat|undefined>()
    const detailOldUserSeat = ref<UserSeat|undefined>()
    const detailPurchase = ref<Purchase|undefined>()
    const detailOldPurchase = ref<Purchase|undefined>()
    const detailExtraSeatsPause = ref<ExtraSeatsPause|undefined>()
    const detailOldExtraSeatsPause = ref<ExtraSeatsPause|undefined>()

    const cleanDetails = () => {
      detailUserSeat.value = undefined
      detailOldUserSeat.value = undefined
      detailPurchase.value = undefined
      detailOldPurchase.value = undefined
      detailExtraSeatsPause.value = undefined
      detailOldExtraSeatsPause.value = undefined
      detailItem.value = undefined
    }

    return {
      query,
      userOptions : computed(()=>{
        return globals.users.value.map(i => {
          return { title : i.name + ' ' + i.surname, value : i._id, fiscal_code : i.fiscal_code }
        })
      }),
      collectionOptions : [
        { title : "Vendita", value : "purchases"},
        { title : "Sedute utente", value : "user_seats"},
        { title : "Extra tempo pausa", value : "extra_seats"}
      ],
      operationOptions : [
        { title : "Inserimento", value : "create"},
        { title : "Modifica", value : "update"},
        { title : "Cancellazione", value : "delete"},
      ],
      onListError(e:DataTableError) {
        if(e.status === 401) {
          messages.error(Msg.permissionError)
          auth.logout()
          return
        }
        messages.error(`Errore: ${e.message}`)
      },
      headers : [
        { title : 'Utente', sortable: true, align: 'left', value : 'user.surname' },
        { title : 'Data', sortable: true, align: 'left', value : 'date' },
        { title : 'Tipologia', sortable: true, align: 'left', value : 'collection' },
        { title : 'Operazione', sortable: true, align: 'left', value : 'operation' },
        { title : 'Cambiamenti', sortable: false, align: 'left', value : 'changed_fields' },
        { title : 'Dettaglio', sortable: false, align: 'left', value : 'item' },
      ],
      formatDateTime : utils.formatDateTime,
      getUserName(id:string) {
        const user = globals.users.value.find(u => u._id === id)
        return user ? `${user.surname} ${user.name} (${user.email})` : `${id} (utente eliminato)`
      },
      detailDialog,
      detailItem,
      detailUserSeat,
      detailOldUserSeat,
      detailPurchase,
      detailOldPurchase,
      detailExtraSeatsPause,
      detailOldExtraSeatsPause,
      cleanDetails,
      openDetail(item:TopGymLog) {
        cleanDetails();

        detailItem.value = item


        //console.log('isUserSeat', isUserSeat(item.item))
        //console.log('isPurchase', isPurchase(item.item))
        //console.log('isExtraSeatsPause', isExtraSeatsPause(item.item))

        if(isUserSeat(item.item)) {
          detailUserSeat.value = item.item
          if(item.old_item) {
            detailOldUserSeat.value = item.old_item as UserSeat
          }
        }

        if(isPurchase(item.item)) {
          detailPurchase.value = item.item
          if(item.old_item) {
            detailOldPurchase.value = item.old_item as Purchase
          }
        }
        if(isExtraSeatsPause(item.item)) {
          detailExtraSeatsPause.value = item.item
          if(item.old_item) {
            detailOldExtraSeatsPause.value = item.old_item as ExtraSeatsPause
          }
        }

        detailDialog.value = true
      },
      saveQuery() {
        utils.setSessionQuery('logs', query.value)
      }
    }
  }
})
</script>

<style scoped>

</style>